import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "bordered-card bordered-card_secondary w-100 mb-60"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 sm-fs-xs" }, "DOCUMENTS CURRENTLY ON FILE/PENDING ADMIN PREVIEW", -1)
const _hoisted_5 = { class: "small mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Participant/Beneficiary"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: "<h2 class='text-medium-green'> Coming Soon </h2>  <br /> To add or change an existing beneficiary or to assign which Fund applies to such beneficiary(ies) please click on the links below to download the applicable beneficiary form for each Fund. Please complete the form(s) and return to the Fund Office via email to psc@iatsenbf.org or you can fax it to us at 212-730-7706.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (link, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "bordered-card"
            }, [
              _createElementVNode("a", {
                href: link,
                target: "_blank"
              }, _toDisplayString(key), 9, _hoisted_2)
            ]))
          }), 128)),
          (_ctx.beneStore.documents?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("table", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.beneStore.documents, (document, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            href: "javascript;",
                            onClick: _withModifiers(($event: any) => (_ctx.openModal('smartsearch', null, 'modal-success', null, { DocumentID: document.DocumentID })), ["prevent"])
                          }, _toDisplayString(document?.Description), 9, _hoisted_7)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(document.Beneficiary), 1),
                        _createElementVNode("td", null, _toDisplayString(document.Date), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass({ 'text-danger': document.Status === 'Pending' })
                        }, _toDisplayString(document.Status), 3)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}